import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import { getCircular } from "../Service/Api";
import { Link } from "react-router-dom";
const Recruitment = () => {
  useEffect(() => {
    document.title = "Recruitment -  The Air Force School Subroto Park";
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const cirData1 = await getCircular();
        const recruitmentData = cirData1.filter(
          (item) => item.category === "Recruitment"
        );
        setData(recruitmentData);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);

  /*     const [recruitmentData, setRecruitmentData] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          
          const cirData1 = await getCircular();
           const cirData = cirData1.filter((item) =>  item.category === "Recruitment" ); 
            cirData.sort((a,b) => new Date(b.fromDate) - new Date(a.fromDate)); 
          setRecruitmentData(cirData || []);
        } catch (error) {
          console.error("Failed to fetch news:", error); 
          setRecruitmentData([]);
        }
      };
      fetchData();
    }, []);
    const emptyArray = [
        { },
    ]; */

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Recruitment</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Recruitment </h1>
            </div>
          </div>
          <div className="row Recruitment">
            {/* <p> <b>WALK-IN INTERVIEW FOR TEACHING/NON-TEACHING STAFF (CONTRACTUAL)</b> </p>
                   
                   <p><b>FOR THE ACADEMIC SESSION 2025-26</b>   </p> */}
            {/* <p>
              {" "}
              <b>
                RECRUITMENT OF TEACHING/NON-TEACHING STAFF (REGULAR AND
                CONTRACTUAL POSTS) AT THREE DELHI BASED AIR FORCE SCHOOLS FOR
                THE ACADEMIC SESSION 2026-27
              </b>
            </p> */}
            {data.length > 0
              ? data
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((item, index) => (
                    <div className="col-lg-6" key={index}>
                      <div className="linktab">
                        {item.attachments && item.attachments.length > 0 ? (
                          <Link
                            to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            />
                          </Link>
                        ) : (
                          <Link
                            to={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            />
                          </Link>
                        )}
                      </div>
                    </div>
                  ))
              : null}
          </div>

          <div className="row">
            <div className="col-lg-12">
              {/* <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/RecruitmentNotification.pdf" target="_blank"> Notification </Link> </div>
                </div>
               <div className="col-lg-4">
                 <div className="linktab"> <Link to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/InterviewSchedule.pdf" target="_blank"> Application Form </Link> </div>
              </div>   */}
              {/* {recruitmentData.length > 0 ? (
                        recruitmentData.map((item, index) => (
                          <ul className="list tender recruitment"> 
                              <li key={index}>  
                                <div className="recruitmentbox">
                                    <h6>{item.title}</h6>
                                    <p> <div dangerouslySetInnerHTML={{ __html: item.description }} /></p>  
                                </div>
                               <div className="multiatttch">
                                  {item.attachments?.[0] && (
                                    item.attachments.map((attch,index) =>(
                                      <Link key={index}
                                      to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${attch}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Click Here
                                    </Link>
                                    ))  
                              )}
                             </div></li>
                          </ul>
                        ))
                      ) : (
                        <p> </p>
                      )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recruitment;
